// src/store/slices/user/userSlice.ts
import { createSlice } from '@reduxjs/toolkit';

import { initialUserState } from '@/types/user/UserState';
import { updateMeThunk } from '@/store/thunks/user/updateThunk';
import { fetchNotificationsThunk } from '@/store/thunks/user/fetchNotificationsThunk';
import { getMeThunk } from '@/store/thunks/user/getMeThunk';
import { isFieldErrors } from '@/utils/type-guards';

export const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    clearUserFieldErrors(state) {
      state.fieldErrors = {};
    }
  },
  extraReducers: (builder) => {
    builder
      // GET ME
      .addCase(getMeThunk.pending, (state) => {
        state.loadingUser = true;
        state.fieldErrors = {};
      })
      .addCase(getMeThunk.fulfilled, (state, action) => {
        state.loadingUser = false;
        const { payload } = action;
        state.user = payload;
      })
      .addCase(getMeThunk.rejected, (state, action) => {
        state.loadingUser = false;
        state.user = null;
       state.fieldErrors =
          action.payload !== null &&
          typeof action.payload === 'object' &&
          'fieldErrors' in (action.payload) &&
          isFieldErrors((action.payload).fieldErrors)
            ? (action.payload).fieldErrors
            : {};
      })
      // UPDATE ME
      .addCase(updateMeThunk.pending, (state) => {
        state.loadingUser = true;
        state.fieldErrors = {};
      })
      .addCase(updateMeThunk.fulfilled, (state, action) => {
        state.loadingUser = false;
        const { payload } = action;
        state.user = payload;
      })
      .addCase(updateMeThunk.rejected, (state, action) => {
        state.loadingUser = false;
     state.fieldErrors =
          action.payload !== null &&
          typeof action.payload === 'object' &&
          'fieldErrors' in (action.payload) &&
          isFieldErrors((action.payload).fieldErrors)
            ? (action.payload).fieldErrors
            : {};
      })
      // FETCH NOTIFICATIONS
      .addCase(fetchNotificationsThunk.pending, (state) => {
        state.loadingNotifications = true;
      })
      .addCase(fetchNotificationsThunk.fulfilled, (state, action) => {
        state.loadingNotifications = false;
        const { payload } = action;
        state.notifications = payload;
      })
      .addCase(fetchNotificationsThunk.rejected, (state) => {
        state.loadingNotifications = false;
      });
  }
});

const { actions } = userSlice;
export const { clearUserFieldErrors } = actions;
export default userSlice.reducer;
